export default {
  home: 'الرئيسية',
  aboutUs: 'من نحن',
  services: 'خدماتنا',
  mediaCenter: 'المركز الإعلامى',
  contactUs: 'تواصل',
  searchInAllDepartments: 'بحث فى جميع الأقسام'
}
